<template>
	<fieldset class="inline">
		<b-form-group
			id="input-group-clientele_type"
			label="Quelle est la répartition en pourcentage de votre clientèle affaires et tourisme?"
			label-for="clientele_type"
			description=""
		>
			<b-form-input
				id="clientele_type"
				type="text"
				v-model="graphics.clientele_type"
				@input="$emit('update:clientele_type', $event)"
				required
				placeholder="Ex. 80%  Affaires, 20% Tourisme"
			>
			</b-form-input>
		</b-form-group>

		<b-form-group
			id="input-group-unique_selling_points"
			label="Qu'est-ce qui vous démarque de la concurrence / quels sont vos principaux atouts?"
			label-for="unique_selling_points"
			description=""
		>
			<b-form-textarea
				id="unique_selling_points"
				v-model="graphics.unique_selling_points"
				@input="$emit('update:unique_selling_points', $event)"
				required
				placeholder="Listez ici les points forts de votre établissement"
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-principal_rivals"
			label="Qui sont vos principaux concurrents?"
			label-for="principal_rivals"
			description=""
		>
			<b-form-textarea
				id="principal_rivals"
				v-model="graphics.principal_rivals"
				@input="$emit('update:principal_rivals', $event)"
				required
				placeholder="Listez ici vos principaux concurrents"
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-color_preferences"
			label="Quelle couleur principale souhaitez-vous utiliser sur votre site?"
			label-for="color_preferences"
			description=""
		>
			<b-form-textarea
				id="color_preferences"
				v-model="graphics.color_preferences"
				@input="$emit('update:color_preferences', $event)"
				required
				placeholder="Mettez ici la couleur que vous aimeriez utiliser"
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-color_dislikes"
			label="Y a-t-il des couleurs que vous ne souhaitez pas utiliser?"
			label-for="color_dislikes"
			description=""
		>
			<b-form-textarea
				id="color_dislikes"
				v-model="graphics.color_dislikes"
				@input="$emit('update:color_dislikes', $event)"
				required
				placeholder="Listez ici les couleurs que vous n'aimeriez pas utiliser"
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-logo"
			label="Avez vous déjà un Logo ? Et si oui, l'avez vous sur un fichier de qualité ?"
			label-for="logo"
			description=""
		>
			<b-form-textarea
				id="graphics-logo"
				v-model="graphics.logo"
				@input="$emit('update:logo', $event)"
				required
				placeholder=""
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-motif_ideas"
			label="Avez-vous déjà un symbole ou motif asssocié à votre établissement?"
			label-for="motif_ideas"
			description=""
		>
			<b-form-textarea
				id="motif_ideas"
				v-model="graphics.motif_ideas"
				@input="$emit('update:motif_ideas', $event)"
				required
				placeholder="Ex. Fleur de Lys, emblème "
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-design_adjectives"
			label="Quels adjectifs décrivent le mieux votre établissement? "
			label-for="design_adjectives"
			description=""
		>
			<b-form-textarea
				id="design_adjectives"
				v-model="graphics.design_adjectives"
				@input="$emit('update:design_adjectives', $event)"
				required
				placeholder="Ex. Sérieux, fun, jeune, luxe, écologique, design, cosy, naturel..."
			>
			</b-form-textarea>
		</b-form-group>

		<b-form-group
			id="input-group-example_sites"
			label="Mettez ici 1 à 3 exemples de sites qui vous plaisent. Qu'est-ce qui vous plait exactement dans chaque exemple?"
			label-for="example_sites"
			description=""
		>
			<b-form-textarea
				id="example_sites"
				v-model="graphics.example_sites"
				@input="$emit('update:example_sites', $event)"
				required
				placeholder="Listez ici les adresses des sites que vous aimez"
				rows="10"
			>
			</b-form-textarea>
		</b-form-group>
	</fieldset>
</template>

<script>
export default {
	name: 'FormGraphics',
	props: ['graphics'],
};
</script>
